<template>
  <div class="row">
    <div class="col-sm-6">
      <transition name="el-fade-in-linear">
        <product-data :product="product" v-if="product"
          @deleteProduct="deleteProduct"
        />
      </transition>
      <transition name="el-fade-in-linear">
        <info-highlights-card v-if="product"
          :comments="product.info_highlights"
          @addComment="addComment"
          @deleteComment="deleteComment"
        />
      </transition>
      <transition name="el-fade-in-linear">
        <card class="stacked-form" v-if="product">
          <template slot="header">
            <div class="d-flex justify-content-between">
              <h4 class="card-title">Fotos</h4>
              <button type="submit" class="btn btn-fill btn-sm" @click="editPictures = !editPictures"
                :class="editPictures ? 'btn-default' : 'btn-primary'"
              >
                <i class="fa fa-edit"></i>
              </button>
            </div>
          </template>
          <div class="row">
            <div class="col-sm-3 text-center" v-for="picture in product.pictures" :key="picture.id">
              <component :is="editPictures ? 'div' : 'a'"
                :href="`${api}/../storage/pictures/${picture.path}`" target="_blank"
              >
                <img :src="`${api}/../storage/pictures/${picture.path}`" class="img-thumbnail">
                <button class="btn btn-sm btn-danger" v-if="editPictures"
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%);"
                  @click="deletePicture(picture)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </component>
            </div>
          </div>
          <div class="dropbox" v-show="editPictures">
            <input type="file" multiple accept="image/*"
              @change="picturesChange"
            >
            <p v-if="!uploadingPictures">
              Ziehen Sie die Foto(s) hierher, <br> oder klicken Sie zum Durchsuchen.
            </p>
            <p v-else><i class="fas fa-spinner fa-pulse"></i> Dateien werden hochgeladen...</p>
          </div>
        </card>
      </transition>
    </div>
    <div class="col-sm-6">
      <card v-if="product">
        <template slot="header">
          <h4 class="card-title">Kategorien & Eigenschaften</h4>
        </template>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>Eigenschaft</th>
                <th>Wert</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="feature in product.product_features" :key="feature.id">
                <td>{{ feature.feature.name }}</td>
                <td>{{ (feature.feature_options && feature.feature_options.length) ?
                  feature.feature_options.map(fO => fO.value).join(', ') :
                  (feature.feature_option ? feature.feature_option.value : feature.feature_option_value)
                }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
      <!--
      <div style="margin-bottom: 1em;" class="d-flex justify-content-between">
        <router-link
          :to="`/?product=${product ? product.id : ''}`"
            class="btn btn-warning btn-xs"
        >
          <i class="fas fa-exchange-alt"></i>
          Lagerbewegung erfassen
        </router-link>
        <el-dropdown trigger="click" v-if="$store.state.customLabels === 'medspa'">
          <button type="submit" class="btn btn-warning">
            <i class="fas fa-money-check"></i> Label drucken<i class="el-icon-arrow-down el-icon--right"></i>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/small`"
                target="_blank"
              >
                38x11mm
              </a>
            </el-dropdown-item>
            <el-dropdown-item>
              <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/medium`"
                target="_blank"
              >
                28x51mm
              </a>
            </el-dropdown-item>
            <el-dropdown-item>
              <a class="dropdown-item" :href="`${api}/products/${product ? product.id : ''}/custom_label/large`"
                target="_blank"
              >
                57x32mm
              </a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <router-link v-if="$store.state.activatedLabels.length > 1"
          :to="`/labels?product=${product ? product.id : ''}`"
            class="btn btn-warning btn-xs"
        >
          <i class="fas fa-tags"></i>
          Etiketten drucken
        </router-link>
        <div>
          <a :href="`${api}/products/${product ? product.id : ''}/custom_label/barcode`"
            target="_blank" class="btn btn-warning btn-xs"
          >
            <i class="fas fa-barcode"></i>
            Barcode drucken
          </a>
        </div>
      </div>
      -->
      <card v-if="product && ! product.has_variations">
        <template slot="header">
          <h4 class="card-title">Lagerstand</h4>
        </template>
        <div class="row">
          <div class="col-sm-12">
            <transition name="el-fade-in-linear">
              <table class="table" v-if="productWarehouses.length">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th class="text-center">Menge</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="stockRotation in productWarehouses" :key="stockRotation.warehouse_id">
                    <td v-text="stockRotation.warehouse.short_name"></td>
                    <td class="text-right" v-text="stockRotation.quantity"></td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr style="border-top: 4px double;">
                    <td colspan="2" class="text-right">{{ inStock }}</td>
                  </tr>
                </tfoot>
              </table>
              <p v-else>Keine Lagerbewegungen für dieses Produkt vorhanden</p>
            </transition>
            <br>
          </div>
        </div>
      </card>
      <card v-if="product && product.has_variations">
        <template slot="header">
          <h4 class="card-title">Lagerstand</h4>
        </template>
        <div>
          <product-variations-warehouses
            :product-variations-warehouses="productVariationsWarehouses"
          />
        </div>
      </card>
      <card v-if="product && product.has_variations">
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Variationen</h4>
            <div class="d-flex">
              <button class="btn btn-fill btn-primary" style="margin-right: 10px;"
                @click="openAddVariationsInstanceDialog"
                :disabled="! filteredVariations.length"
              >
                Instanzieren
              </button>
              <button class="btn btn-fill btn-primary" style="margin-right: 10px;"
                @click="$router.push(`/products/${product.id}/variations/fast_create`)"
              >
                Schnellanlage
              </button>
              <button class="btn btn-fill btn-primary"
                @click="$router.push(`/products/${product.id}/variations/create`)"
              >
                Hinzufügen
              </button>
            </div>
          </div>
        </template>
        <div class="row">
          <div class="col-sm-12">
            <transition name="el-fade-in-linear">
              <div v-if="product.variations.length">
                <div class="row">
                  <div class="col-sm-4"
                    v-for="feature in featuresToFilterFrom" :key="feature.id"
                  >
                    <div class="form-group has-label">
                      <label><strong>{{ feature.feature.name }}</strong></label>
                      <multiselect v-model="variationsFilters[feature.feature.id]"
                        :options="feature.feature.options"
                        track-by="id"
                        label="value"
                      />
                    </div>
                  </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th></th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="variation in filteredVariations" :key="variation.id">
                      <td>
                        <router-link :to="`/products/${variation.id}`">
                          {{ variation.name }}
                        </router-link>
                      </td>
                      <td>
                        <ul style="margin-bottom: 0;">
                          <li v-for="stringRep in variation.stringRep" :key="stringRep" v-text="stringRep"></li>
                        </ul>
                      </td>
                      <td class="text-right">
                        <div class="td-actions-custom">
                          <router-link :to="`/products/${variation.id}/edit`"  class="btn btn-warning btn-link btn-xs">
                            <i class="fa fa-edit"></i>
                          </router-link>
                          <a class="btn btn-danger btn-link btn-xs"
                            href="#" @click.prevent="deleteVariation(variation)"
                          >
                            <i class="fa fa-close"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p v-else>Noch keine Variationen für dieses Produkt vorhanden</p>
            </transition>
            <br>
          </div>
        </div>
      </card>
      <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Letzten Lagerbewegungen</h4>
            <div>
              <router-link :to="`/stock_rotations?product=${this.$route.params.id}`" class="logo-mini">
                <i class="fas fa-exchange-alt" aria-hidden="true"></i> Alle anzeigen
              </router-link>
            </div>
          </div>
        </template>
        <div class="row">
          <div class="col-sm-12">
            <transition name="el-fade-in-linear">
              <table class="table table-striped table-bordered" v-if="lastStockRotations.length">
                <thead>
                  <tr>
                    <th>Datum</th>
                    <th>Produkt</th>
                    <th>Preis</th>
                    <th>Grund</th>
                    <th>User</th>
                    <th>Kostenstelle</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr is="StockRotationRow"
                    v-for="lastStockRotation in lastStockRotations"
                    :key="lastStockRotation.id"
                    :stock-rotation="lastStockRotation"
                    :accumulated="false"
                    :show-warehouse="false"
                    @deleteStockRotation="deleteStockRotation"
                  />
                </tbody>
              </table>
              <p v-else>Keine Lagerbewegungen für dieses Produkt vorhanden</p>
            </transition>
            <br>
          </div>
        </div>
      </card>
      <card v-if="product && ! product.has_variations">
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Instanzen</h4>
            <button type="submit" class="btn btn-fill btn-primary"
              @click="openAddInstanceDialog"
            >
              Hinzufügen
            </button>
          </div>
        </template>
        <div class="row">
          <div class="col-sm-12">
            <transition name="el-fade-in-linear">
              <table class="table" v-if="product.instances.length">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="instance in product.instances" :key="instance.id">
                    <td>
                      <router-link :to="`/product_instances/${instance.id}`">
                        {{ instance.id }}
                      </router-link>
                    </td>
                    <td class="text-right">
                      <a class="btn btn-warning btn-xs btn-link" href="#"
                        @click.prevent="instanceLabel(instance)"
                      >
                        Label drucken
                        <i class="fas fa-barcode"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p v-else>Noch keine Instanzen für dieses Produkt vorhanden</p>
            </transition>
            <br>
          </div>
        </div>
      </card>
      <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Lieferanten</h4>
            <button type="submit" class="btn btn-fill btn-primary"
              @click="openAssignToSuppliersDialog"
            >
              Zuweisen
            </button>
          </div>
        </template>
        <product-suppliers-table
          :suppliers="productSuppliers"
          @deleteProductSupplier="deleteProductSupplier"
          @bla="bla"
          :product="product"
        />
      </card>
      <files-card
        :files="files"
        :base-url="`${api}/products/${$route.params.id}/files`"
        @fileUploaded="fileUploaded"
        @fileDeleted="fileDeleted"
      />
      <!-- <card>
        <template slot="header">
          <div class="d-flex justify-content-between">
            <h4 class="card-title">Alternativen</h4>
          </div>
        </template>
        <transition name="el-fade-in-linear">
          <products-table v-if="product && product.alternatives.length"
            :products="product.alternatives"
            :onlyShowAction="true"
          />
          <p v-if="product && ! product.alternatives.length">Keine Alternativen vorhanden</p>
        </transition>
      </card> -->
    </div>
    <assign-to-supplier-dialog v-if="product"
      :show="showAssignToSuppliersDialog"
      :suppliers="suppliers"
      @assignToSupplier="assignToSupplier"
      @close="showAssignToSuppliersDialog = false"
      :val-errors="assignErrors"
      :init-price="product.standard_price || ''"
    />
    <add-instance-dialog v-if="product"
      :show="showAddInstanceDialog"
      @addInstance="addInstance"
      @close="closeAddInstanceDialog"
      :val-errors="instanceErrors"
    />
    <add-product-variation-instance-dialog v-if="product"
      :show="showAddVariationsInstanceDialog"
      :product-id="product.id"
      :variations="filteredVariations"
      @close="closeAddVariationsInstanceDialog"
      @created="openLabelsDialog"
    />
  </div>
</template>

<script>
import showLabelsAlert from 'src/productInstancesLabelsAlert'
import ProductSuppliersTable from './product-suppliers-table'
import AssignToSupplierDialog from './assign-to-supplier-dialog'
import AddInstanceDialog from './add-instance-dialog'
import ProductData from './product-data'
// import ProductsTable from './products-table'
import { groupNewestSuppliers } from 'src/util/helpers'
import api from 'src/api'
import { Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import StockRotationRow from 'src/pages/StockRotations/stock-rotation-row'
import FilesCard from 'src/components/files-card'
import ProductVariationsWarehouses from 'src/components/product-variations-warehouses'
import AddProductVariationInstanceDialog from './add-product-variation-instance-dialog'
import InfoHighlightsCard from 'src/components/info-highlights-card'

export default {
  components: {
    FilesCard,
    ProductData,
    StockRotationRow,
    AddInstanceDialog,
    ProductSuppliersTable,
    AssignToSupplierDialog,
    ProductVariationsWarehouses,
    AddProductVariationInstanceDialog,
    InfoHighlightsCard,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data () {
    return {
      api,
      product: null,
      productSuppliersFetched: [],
      productWarehouses: [],
      showAssignToSuppliersDialog: false,
      showAddInstanceDialog: false,
      showAddVariationsInstanceDialog: false,
      assignErrors: [],
      instanceErrors: [],
      suppliers: [],
      lastStockRotations: [],
      files: [],
      productVariationsWarehouses: [],
      uploadingPictures: false,
      editPictures: false,
      variationsFilters: {}
    }
  },
  methods: {
    openAssignToSuppliersDialog () {
      let loadSuppliers = Promise.resolve()
      if (!this.suppliers.length) {
        loadSuppliers = this.$http.get(`/suppliers`).then(({ data }) => {
          this.suppliers = data
        })
      }
      loadSuppliers.then(() => { this.showAssignToSuppliersDialog = true })
    },
    async assignToSupplier (payload) {
      await this.initCsrf()

      const url = `/products/${this.product.id}/suppliers/${payload.supplier_id}`
      this.$http.post(url, { price: payload.price }).then(({ data }) => {
        this.$notify({
          message: 'Produkt erfolgreich dem Lieferanten zugewiesen.',
          type: 'success'
        })
        this.showAssignToSuppliersDialog = false
        this.productSuppliersFetched.unshift(data)
      }).catch(({ response }) => { this.assignErrors = response.data.errors })
    },
    showProduct (product) {
      this.$router.push({ path: `/products/${product.id}` })
    },
    fetchStockRotations () {
      // fetch last stock rotations for product or variation
      if (this.product.is_variation_of || !this.product.has_variations) {
        this.$http.get(`/stock_rotations?product_variation=${this.$route.params.id}&limit=5`).then(({ data }) => {
          this.lastStockRotations = data
        })
        this.$http.get(`/products/${this.$route.params.id}/warehouses`).then(({ data }) => {
          this.productWarehouses = data
        })
      } else {
        this.$http.get(`/stock_rotations?product=${this.$route.params.id}&limit=5`).then(({ data }) => {
          this.lastStockRotations = data
        })
        this.$http.get(`/products/${this.$route.params.id}/variations/warehouses`).then(({ data }) => {
          this.productVariationsWarehouses = data
        })
      }
    },
    fetchData () {
      this.$http.get(`/products/${this.$route.params.id}`).then(({ data }) => {
        data.variations = data.variations.map(variation => {
          variation.instancesToCreate = null
          return variation
        })
        this.product = data
        this.variationsFilters = this.featuresToFilterFrom.reduce((sum, feature) => {
          sum[feature.feature.id] = null
          return sum
        }, {})
        this.fetchStockRotations()
      })
      this.$http.get(`/products/${this.$route.params.id}/suppliers`).then(({ data }) => {
        this.productSuppliersFetched = data
      })
      this.$http.get(`/products/${this.$route.params.id}/files`).then(({ data }) => {
        this.files = data
      })
    },
    async deleteProductSupplier (supplier) {
      if (confirm('Zuweisung zum Lieferanten wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/product_supplier/${supplier.id}`).then(({ data }) => {
          const index = this.productSuppliersFetched.findIndex(({ id }) => id === data.id)
          this.productSuppliersFetched.splice(index, 1)
        })
      }
    },
    bla (blub) {
      this.productSuppliersFetched.unshift(blub)
    },
    async deleteStockRotation (stockRotation) {
      if (confirm('Lagerbewegung wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/stock_rotations/${stockRotation.id}`).then(({ data }) => {
          this.$notify({
            message: `Lagerbewegung erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.lastStockRotations.findIndex(({ id }) => data.id === id)
          this.lastStockRotations.splice(index, 1)
        })
      }
    },
    async deleteProduct () {
      if (confirm(`Produkt ${this.product.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/products/${this.product.id}`).then(({ data }) => {
          this.$notify({
            message: `Produkt ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          this.$router.push('/products')
        })
      }
    },
    async deleteVariation (variation) {
      if (confirm(`Variation wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/products/${variation.id}`).then(({ data }) => {
          this.$notify({
            message: `Variation erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.product.variations.findIndex(({ id }) => id === variation.id)
          this.product.variations.splice(index, 1)
        })
      }
    },
    openAddInstanceDialog () {
      this.showAddInstanceDialog = true
    },
    closeAddInstanceDialog () {
      this.showAddInstanceDialog = false
      this.instanceErrors = []
    },
    async addInstance (reqData) {
      await this.initCsrf()

      const url = `/products/${this.product.id}/instances`
      this.$http.post(url, reqData).then(({ data }) => {
        this.showAddInstanceDialog = false
        this.product.instances.push(...data)
        this.fetchStockRotations()
        this.$notify({
          message: 'Die Instanzierung wurden erfolgreich erfasst.',
          type: 'success'
        })
        showLabelsAlert(data)
      }).catch(({ response }) => { this.instanceErrors = response.data.errors })
    },
    instanceLabel (instance) {
      showLabelsAlert([instance])
    },
    fileUploaded (file) {
      this.files.unshift(file)
    },
    fileDeleted (file) {
      const index = this.files.findIndex(({ id }) => file.id === id)
      this.files.splice(index, 1)
    },
    picturesChange (event) {
      this.uploadingPictures = true

      const formData = new FormData()
      const fileList = event.target.files

      if (!fileList.length) return

      [...fileList].forEach(file => {
        formData.append('pictures[]', file)
      })

      const headers = { 'Content-Type': 'multipart/form-data' }

      this.$http.post(`/products/${this.product.id}/pictures`, formData, { headers }).then(({ data }) => {
        this.product.pictures.push(...data)
      }).catch(({ response }) => {
        console.log(response.data.errors)
      }).then(() => {
        this.uploadingPictures = false
      })
    },
    async deletePicture (picture) {
      if (confirm(`Foto wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/products/${this.product.id}/pictures/${picture.id}`).then(({ data }) => {
          this.$notify({
            message: `Foto erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.product.pictures.findIndex(({ id }) => picture.id === id)
          this.product.pictures.splice(index, 1)
        })
      }
    },
    openAddVariationsInstanceDialog () {
      this.showAddVariationsInstanceDialog = true
    },
    closeAddVariationsInstanceDialog () {
      this.showAddVariationsInstanceDialog = false
      this.product.variations.forEach(variation => {
        variation.instancesToCreate = null
      })
    },
    openLabelsDialog (data) {
      this.closeAddVariationsInstanceDialog()
      this.fetchStockRotations()
      this.$notify({
        message: 'Die Instanzierung wurden erfolgreich erfasst.',
        type: 'success'
      })
      showLabelsAlert(data)
    },
    async addComment (comment) {
      await this.initCsrf()

      this.$http.post(`/products/${this.product.id}/info_highlights`, { comment }).then(({ data }) => {
        this.product.info_highlights.unshift(data)
      }).catch(({ response }) => {
        console.log(response.data.errors)
      })
    },
    async deleteComment (comment) {
      if (confirm('Info zu Stoffen, Highlights wirklich löschen?')) {
        await this.initCsrf()

        this.$http.delete(`/products/${this.product.id}/info_highlights/${comment.id}`).then(({ data }) => {
          const index = this.product.info_highlights.findIndex(({ id }) => id === data.id)
          this.product.info_highlights.splice(index, 1)
          this.$notify({
            message: 'Der Eintrag zu Info zu Stoffen, Highlights wurden erfolgreich gelöscht.',
            type: 'success'
          })
        }).catch(({ response }) => {
          console.log(response.data.errors)
        })
      }
    }
  },
  computed: {
    inStock () {
      return this.productWarehouses.reduce((sum, stockRotation) => sum + +stockRotation.quantity, 0)
    },
    productSuppliers () {
      return groupNewestSuppliers(this.productSuppliersFetched)
    },
    cheapestSupplier () {
      return this.productSuppliersFetched.length ? this.productSuppliersFetched[0] : ''
    },
    featuresToFilterFrom () {
      return this.product.product_features.filter(feature => feature.feature.type === 'dropdown')
    },
    filteredVariations () {
      return this.product.variations.filter(variation => {
        return Object.keys(this.variationsFilters).every((featureId) => {
          if (this.variationsFilters[featureId]) {
            const productFeature = variation.product_features.find(pF => pF.feature.id == featureId)
            return productFeature.feature_option_id == this.variationsFilters[featureId].id
          }
          return true
        })
      })
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  }
}
</script>
